import { ApiResponse, ApiResponseContent, NameIdSlim } from '../models/custom-models';
import { ProficiencyGraph, ScoreCard, TemplateRevision2ProficiencyGroupDisplay, UpdateProficiencySelection } from '../models/dtos';
import ApiBase from './base/ApiBase'

class ProfileClient extends ApiBase {
    private controllerName: string = 'Template/Profile';

    async Create(id: string, dto: CreateProfile, signal?: AbortSignal): Promise<ApiResponseContent<string>> {
        return this.PostAsync(`${this.controllerName}/${id}`, dto, signal);
    }
    
    async GetSingleGraph(id: string, signal?: AbortSignal): Promise<ProfileGraph> {
        return this.GetAsync(`${this.controllerName}/${id}`, signal);
    }

    async Publish(id: string, signal?: AbortSignal): Promise<void> {
        return this.PostAsync(`${this.controllerName}/${id}/Publish`, signal);
    }

    async SetProficiencyWeight(id: string, context: SetWeightContext, signal?: AbortSignal) : Promise<ApiResponse>
    {
        return this.PutAsync(`${this.controllerName}/${id}/SetWeight`, context, signal);
    }

    async UpdateProficiency(id: string, dto: UpdateProficiencySelection, signal?: AbortSignal): Promise<void> {
        return this.PutAsync(`${this.controllerName}/${id}`, dto, signal);
    }
}

export interface CreateProfile{
    SourceProfileId: string;
    ProfileName: string;
}

export interface ProfileGraph {
    TemplateRevisionId: string;
    Profile: NameIdSlim;
    Proficiencies: ProficiencyGraph[];
    TemplateRevision2ProficiencyGroupDisplays: TemplateRevision2ProficiencyGroupDisplay[];
    ScoreCard: ScoreCard;
}

export interface SetWeightContext {
 ProficiencyId: string;
 Weight: string;
}

export enum ProfileErrors {
    Create = 'Error creating profile',
    Delete = 'Error deleting profile',
    GetSingle = 'Error loading profile',
    GetAll = 'Error loading profile',
    Update = 'Error saving profile'
}

export default ProfileClient;